import { styled } from '@mui/material/styles';
import { Card, CardHeader } from 'shared/mui/Card';

export const StyledCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  minWidth: '320px',
  width: '320px',
}));

export const StyledCardHeader = styled(CardHeader)(({ theme }) => ({
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
